module.exports = __webpack_public_path__ + "img/dinning-room.984fdfa3.jpg";